import Bottom from '@components/sections/channelList/content/channelListBottom';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListInfoContainer from '@components/atoms/container/channelListInfoContainer';
import Description from '@components/sections/channelList/content/channelListDescription';
import EmptyContainer from '@components/atoms/container/channelListEmptyContainer';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useContext } from 'react';

/**
 * Component that displays channel list information including description and bottom content.
 * Shows event information when available, or an empty state message when no data is loaded.
 *
 * @returns {JSX.Element} Channel list info container or empty state
 */
export default function ChannelListInfo() {
  const { event, focused, complete } = useContext(ChannelListContext);

  return !complete || event ? (
    <ChannelListInfoContainer
      animation={'channel-list-info'}
      focused={focused}
      id={'channelInfoContainer'}
    >
      <Description />
      <Bottom />
    </ChannelListInfoContainer>
  ) : (
    <EmptyContainer id={'emptyContainer'}>
      {TranslationManager.get('MISC.EMPTY')}
    </EmptyContainer>
  );
}
